import React from 'react';
import fhirpath from 'fhirpath';
import { FiPrinter } from 'react-icons/fi';

import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import { useEnterpriseContext } from '@/features/enterprise/contexts/EnterpriseContext';

import Information from '@/components/Information';
import IconButton from '@/components/IconButton';
import { FhirPedidoType } from '@/features/enterprise/models/types';
import { clinicalDocumentPdf } from '@/features/pdf/documents/ClinicalDocumentLayout';
import DocumentPageEncaminhamento from '@/features/pdf/documents/DocumentPageEncaminhamento';
import { Container, Header, HeaderTitle, Actions } from './styles';

interface BoxEncaminhamentoProps {
  encaminhamento: FhirPedidoType;
  solicitacao_obrigatoria?: boolean;
  solicitacao_obrigatoria_motivo?: string;
}

const BoxEncaminhamento: React.FC<BoxEncaminhamentoProps> = ({
  encaminhamento,
  solicitacao_obrigatoria,
  solicitacao_obrigatoria_motivo,
}) => {
  const [onHover, setOnHover] = React.useState(false);
  const [printing, setPrinting] = React.useState(false);

  const { user } = useAuth();
  const [{ encounter }] = useEnterpriseContext();

  const showImprimirButton = React.useMemo(() => {
    if (user?.empresa) {
      return !!user?.empresa?.features?.find(
        feature => feature.codigo === 'IMPRIMIR_ENCAMINHAMENTO',
      );
    }
    return true;
  }, [user]);

  const titulo = React.useMemo(() => {
    return fhirpath.evaluate(
      encaminhamento,
      'ServiceRequest.code.text | ServiceRequest.code.coding.display',
    )[0];
  }, [encaminhamento]);

  const imprimirEncaminhamento = React.useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      try {
        setPrinting(true);
        await clinicalDocumentPdf(DocumentPageEncaminhamento, {
          user,
          resource: encaminhamento as fhir4.ServiceRequest,
          encounter: encounter.data,
        });
      } catch (error) {
        throw new Error(`Erro ao gerar PDF do encaminhamento: ${error}`);
      } finally {
        setPrinting(false);
      }
    },
    [user, encaminhamento, encounter.data],
  );

  return (
    <Container>
      <Header>
        <HeaderTitle highlight={onHover}>{titulo}</HeaderTitle>

        <Actions>
          {showImprimirButton && (
            <IconButton
              disabled={printing}
              tooltip="Imprimir"
              onClick={imprimirEncaminhamento}
              onMouseOver={() => setOnHover(true)}
              onMouseLeave={() => setOnHover(false)}
              icon={<FiPrinter />}
            />
          )}
        </Actions>
      </Header>

      {solicitacao_obrigatoria && (
        <Information type="warning" style={{ margin: '12px 0 0' }}>
          {solicitacao_obrigatoria_motivo}
        </Information>
      )}
    </Container>
  );
};

export default BoxEncaminhamento;
